/*
 * Copyright (C) 2021 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import {
  NotificationPreferencesContext,
  NotificationPreferencesContextProvider,
} from '@canvas/notification-preferences/react/NotificationPreferencesContextProvider'
import AccountNotificationSettingsQuery from './AccountNotificationSettingsQuery'
import CourseNotificationSettingsQuery from '@canvas/notification-preferences-course/react/CourseNotificationSettingsQuery'
import React from 'react'
import {AlertManager} from '@instructure/platform-alerts'
import {string} from 'prop-types'

export default function AccountNotificationSettingsView({accountId, userId}) {
  return (
    <AlertManager>
      <NotificationPreferencesContextProvider>
        <NotificationPreferencesContext.Consumer>
          {({currentContext}) =>
            currentContext.value === 'account' ? (
              <AccountNotificationSettingsQuery accountId={accountId} userId={userId} />
            ) : (
              <CourseNotificationSettingsQuery courseId={currentContext.value} userId={userId} />
            )
          }
        </NotificationPreferencesContext.Consumer>
      </NotificationPreferencesContextProvider>
    </AlertManager>
  )
}

AccountNotificationSettingsView.propTypes = {
  accountId: string.isRequired,
  userId: string.isRequired,
}
